import { render } from "./ConnectRecord.vue?vue&type=template&id=04fd7ca6&scoped=true"
import script from "./ConnectRecord.vue?vue&type=script&lang=js"
export * from "./ConnectRecord.vue?vue&type=script&lang=js"

import "./ConnectRecord.vue?vue&type=style&index=0&id=04fd7ca6&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fd7ca6"]])

export default __exports__